import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { LANGUAGE } from '../const';
import pl from './langs/pl.json';
import dateTimeFormats from './datetime';

Vue.use(VueI18n);

const messages = {};
messages[LANGUAGE.PL.symbol] = pl;

const i18n = new VueI18n({
  locale: LANGUAGE.PL.symbol,
  messages,
  dateTimeFormats,
});


export {
  i18n as default,
};



// WEBPACK FOOTER //
// ./src/i18n/index.js